import {DefaultInfoV1Props} from "@models/DefaultProps.ts";
import {ISolicitacaoOrcamentoRastreio} from "@models/orcamento/ISolicitacaoOrcamentoRastreio.ts";
import {TableCell, TableRow, Typography} from "@mui/material";
import {statusAprovacaoColor} from "@models/solicitacoes/orcamento.ts";
import {ToDateTimeDefault} from "@shared/MathHelp.ts";

interface CodigoRastreioRowProps extends Omit<DefaultInfoV1Props<ISolicitacaoOrcamentoRastreio>, 'variant'> {
    events?: {
        onUpdate?: (value: ISolicitacaoOrcamentoRastreio) => void;
    }
}

export function CodigoRastreioRow(props: CodigoRastreioRowProps) {
    const {value, EndComponent} = props;

    return (value != null && <TableRow>
            <TableCell>{value.id}</TableCell>
            <TableCell>{value.codigoRastreio}</TableCell>
            <TableCell><Typography color={statusAprovacaoColor(value.status)}>{value.status}</Typography></TableCell>
            <TableCell>{ToDateTimeDefault(value.dataInclusao)}</TableCell>
            <TableCell>{ToDateTimeDefault(value?.dataPrevisaoEntrega)}</TableCell>
            <TableCell>{ToDateTimeDefault(value.dataEntregue)}</TableCell>
            <TableCell>{EndComponent && <EndComponent {...value}/>}</TableCell>
        </TableRow>
    )

}